import { render, staticRenderFns } from "./IcoPeoplePlatform.vue?vue&type=template&id=c6e8d638"
import script from "./IcoPeoplePlatform.vue?vue&type=script&lang=js"
export * from "./IcoPeoplePlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports